"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.arc = void 0;
const polarToCartesian_1 = require("./polarToCartesian");
const arc = (center, radius, startAngle, endAngle) => {
    const start = polarToCartesian_1.polarToCartesian(center, center, radius, startAngle);
    const end = polarToCartesian_1.polarToCartesian(center, center, radius, endAngle);
    const largeArc = endAngle - startAngle <= Math.PI ? '0' : '1';
    return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArc} 1 ${end.x} ${end.y}`;
};
exports.arc = arc;
//# sourceMappingURL=arc.js.map